
import permissions from '../constants/permissions'
import envConfig from '../envConfig'
import { getAppUrl, getVersionUrl } from '../helpers/microApps/buildUrls'
import PermissionsUtil from '../helpers/permissions/PermissionsUtil'
import { isFeatureAllowed, combinePathsWithEnv } from '../helpers/routeUtil'
import Locations from '../helpers/tools/locations'
import { MicroApp } from '../types/microApp'

const microAppUrl = envConfig.apps.virtualTerminal

const App: MicroApp = {
  name: 'virtual_terminal',
  importFunction: async (version: string) => (
    System.import(getAppUrl(microAppUrl, version))
  ),
  getVersion: async (): Promise<string> => {
    const version = await System.import(getVersionUrl(microAppUrl))
    return version.default
  },
  permissionsCheck: () => {
    const requiredPermissions = [
      permissions.payments.create,
      permissions.authorization.create,
      permissions.charge.create,
      permissions.paymentMethod.create,
      permissions.customer.create,
      permissions.customer.get,
      permissions.token.create
    ]
    return isFeatureAllowed(PermissionsUtil.all, requiredPermissions)
  },
  paths: combinePathsWithEnv([Locations.virtualTerminal])
}

export default App
